/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The EmailTemplatesidEmailTemplate model module.
 * @module model/EmailTemplatesidEmailTemplate
 * @version v0.3
 */
export default class EmailTemplatesidEmailTemplate {
  /**
   * Constructs a new <code>EmailTemplatesidEmailTemplate</code>.
   * @alias module:model/EmailTemplatesidEmailTemplate
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailTemplatesidEmailTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailTemplatesidEmailTemplate} obj Optional instance to populate.
   * @return {module:model/EmailTemplatesidEmailTemplate} The populated <code>EmailTemplatesidEmailTemplate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailTemplatesidEmailTemplate();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('subject'))
        obj.subject = ApiClient.convertToType(data['subject'], 'String');
      if (data.hasOwnProperty('body'))
        obj.body = ApiClient.convertToType(data['body'], 'String');
    }
    return obj;
  }
}

/**
 * Name of the email template
 * @member {String} name
 */
EmailTemplatesidEmailTemplate.prototype.name = undefined;

/**
 * Subject line of the email template
 * @member {String} subject
 */
EmailTemplatesidEmailTemplate.prototype.subject = undefined;

/**
 * Body content of the email template
 * @member {String} body
 */
EmailTemplatesidEmailTemplate.prototype.body = undefined;
